import $ from 'jquery';

$('.services-drawer-container').each(function () {
    const $accordions = $(this).find('.accordion');
    $accordions.each(function() {
        const $trigger = $(this).find('.accordion-trigger');
        const $content = $(this).find('.accordion-content');
        $trigger.on('click', function() {
            const isOpen = $(this).hasClass('is-open');
            $('.accordion .accordion-trigger').removeClass('is-open');
            $('.accordion .accordion-content').slideUp();
            if (!isOpen) {
                $(this).addClass('is-open');
                $content.slideToggle();
            }
        });
    });
});
